import type { Company } from '@/data/employees/interfaces';

export enum StatusFilter {
  All = 'all',
  Registered = 'registered',
  Deleted = 'deleted',
}

export interface FiltersProps {
  companies: Company[];
  selectedCompany: Company | null;
  setSelectedCompany: (company: Company | null) => void;
  localSearchTerm: string;
  setLocalSearchTerm: (term: string) => void;
  handleSearch: () => void;
  loading: boolean;
  statusValue: string;
  onStatusChange: (status: string) => void;
}
